import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@narvar/nth-button';
import cx from 'classnames';
import ItemInfo from '../../SidebarItemDetails/SidebarItemDetails';
import ReturnsSidebar from '../../ReturnsSidebar/ReturnsSidebar';
import { orderService } from '../../../services/order-service/order-service';
import { setDeferOverride, setLoading } from '../../../actions/page';
import s from '../returnReasonSidebar.module.css';
import { EVENT_VALUES, EVENTS } from '../../../constants/noflake/noflakeSchema';
import { monitoringService } from '../../../services/monitoring-service/monitoring-service';

const mapStateToProps = ({ page: { loading }, language, restrictions: { maxItemsReached } }) => ({
  language,
  maxItemsReached,
  loading,
});

const OverrideSidebar = ({
  open,
  toggle,
  currentItem,
  sidebarItemAttrs,
  language,
  maxItemsReached,
  dispatch,
  loading,
}) => {
  const [hasError, setHasError] = useState(false);

  const handleOverrideClick = async () => {
    monitoringService.postData({
      type: EVENTS.CLICK,
      value: EVENT_VALUES[EVENTS.CLICK].store_associate_override_button,
    });
    setHasError(false);
    dispatch(setLoading(true));
    dispatch(setDeferOverride(true));
    const newOrder = await orderService.validateOrder({ deferOverride: false });
    if (!newOrder.error) {
      toggle();
      dispatch(setDeferOverride(false));
      dispatch(setLoading(false));
    } else {
      setHasError(true);
      dispatch(setLoading(false));
    }
  };

  return (
    <div role="dialog" tabIndex="0" aria-label="Return Reasons Sidebar" aria-modal={open}>
      <ReturnsSidebar
        title={language['returns.step_1.sidepanel_defer_override.title']}
        toggleSide="right"
        sidebarOpen={open}
        closeIconOnClick={toggle}
        overlayOnClick={toggle}
        disableClose={maxItemsReached}
      >
        <div className={s.panel_content}>
          <ItemInfo
            item={currentItem || {}}
            displayImg
            itemProperties={sidebarItemAttrs}
            language={language}
          />
          {currentItem && currentItem.return_eligibility_message && (
            <p className={s.override_message}>{currentItem.return_eligibility_message}</p>
          )}
          {hasError && (
            <p className={cx(s.override_message, s.sidebar_comments_max_length)}>
              {language['returns.step_1.sidepanel_defer_override.error']}
            </p>
          )}
          <Button
            className={`${s.submit_button} narvar-btn-primary sidebar-done-button sidebar-action-btn`}
            big
            disabled={loading}
            onClick={handleOverrideClick}
          >
            {language['returns.step_1.sidepanel_defer_override.button']}
          </Button>
        </div>
      </ReturnsSidebar>
    </div>
  );
};

OverrideSidebar.propTypes = {
  language: PropTypes.object.isRequired,
  maxItemsReached: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  currentItem: PropTypes.shape({
    return_eligibility_message: PropTypes.string,
  }).isRequired,
  sidebarItemAttrs: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(OverrideSidebar);
